import React from 'react';
import clamp from 'lodash/clamp';

import styles from 'common/query-builder/chart-customization/index.module.styl';
import {AxisUnitPrecision} from 'common/report/insights/util/types';
import {ButtonTheme} from 'common/components/button/constants';
import {ButtonReact} from 'common/components/button';

import {CLEAR_VALUE} from '../axis/constants';
import {AXIS_UNIT_PRECISION_MAX, AXIS_UNIT_PRECISION_MIN} from './constants';

export const DecimalOption = ({
  disabled,
  isLeft,
  precision,
  setPrecision,
}: {
  disabled?: boolean;
  isLeft: boolean;
  precision: AxisUnitPrecision | null;
  setPrecision: (newPrecision: AxisUnitPrecision | null) => void;
}) => {
  // Disable the button if the precision is already at the min/max value.
  disabled ||= (precision === AXIS_UNIT_PRECISION_MIN && isLeft) || (precision === AXIS_UNIT_PRECISION_MAX && !isLeft);
  let newPrecision: AxisUnitPrecision | null = CLEAR_VALUE;
  if (precision === null || precision === undefined) {
    newPrecision = isLeft ? 0 : 1;
  } else {
    if (isLeft) {
      newPrecision = (precision - 1) as AxisUnitPrecision;
    } else {
      newPrecision = (precision + 1) as AxisUnitPrecision;
    }
  }
  newPrecision = clamp(newPrecision!, AXIS_UNIT_PRECISION_MIN, AXIS_UNIT_PRECISION_MAX) as AxisUnitPrecision;
  return (
    <ButtonReact
      disabled={disabled ?? false}
      className={styles.singleInput}
      theme={ButtonTheme.Secondary}
      onClick={() => setPrecision(newPrecision)}
    >
      {isLeft ? `← .0` : `.00 →`}
    </ButtonReact>
  );
};
